import { useSelector } from "react-redux";
import { datasetSelectors } from "../ducks/dataset";

export const useDataset = () => {
  const datasets = useSelector(datasetSelectors.datasets);

  return { datasets };
};
